export default __webpack_public_path__ + "static/media/ags.a18f1473.png";